import React from "react";
import "./campaign.css";

const Campaign: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/banner.png" alt="" />
      </div>
    </div>
  );
};

export const SmallWideBanner: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/two-collum-wide.png" alt="" />
      </div>
    </div>
  );
};

export const TrendingProducts: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/trending-product.png" alt="" />
      </div>
    </div>
  );
};

export const FilterProducts: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/filter-products.png" alt="" />
      </div>
    </div>
  );
};

export const RandomBanners: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/random-banners.png" alt="" />
      </div>
    </div>
  );
};

export const ThreeBannersProducts: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/three-banner-products.png" alt="" />
      </div>
    </div>
  );
};

export const ServicesBanner: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/services.jpg" alt="" />
      </div>
    </div>
  );
};

export const GridBanner: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/grid-banner.jpg" alt="" />
      </div>
    </div>
  );
};

export const VideoSlider: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/video-slider.jpg" alt="" />
      </div>
    </div>
  );
};

export const BannerCollection: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/banner-collection.jpg" alt="" />
      </div>
    </div>
  );
};

export const ReviewsSlider: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/reviews.jpg" alt="" />
      </div>
    </div>
  );
};

export const HalalflixVideos: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/halalflix.png" alt="" />
      </div>
    </div>
  );
};

export const HalalflixCategory: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <img src="/img/widgets/halalflix-category.png" alt="" />
      </div>
    </div>
  );
};

export const InstagramFeed: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <div className="py-6 px-4 border border-dashed border-neutral-300 bg-neutral-50 rounded text-center text-neutral-500 font-sans">
          <p className="text-[10px] font-extrabold uppercase tracking-widest text-neutral-800">Instagram Shoppable Feed</p>
          <p className="text-[9px] text-neutral-400 mt-1">Live Instagram posts with shoppable links</p>
        </div>
      </div>
    </div>
  );
};

export const AnzaarUnique: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <div className="py-6 px-4 border border-dashed border-neutral-300 bg-neutral-50 rounded text-center text-neutral-500 font-sans">
          <p className="text-[10px] font-extrabold uppercase tracking-widest text-neutral-800">Anzaar Unique Features</p>
          <p className="text-[9px] text-neutral-400 mt-1">Brand USPs and Highlights Grid</p>
        </div>
      </div>
    </div>
  );
};

export const BrandStory: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <div className="py-6 px-4 border border-dashed border-neutral-300 bg-neutral-50 rounded text-center text-neutral-500 font-sans">
          <p className="text-[10px] font-extrabold uppercase tracking-widest text-neutral-800">Brand Story Panel</p>
          <p className="text-[9px] text-neutral-400 mt-1">Premium Brand storytelling panel</p>
        </div>
      </div>
    </div>
  );
};

export const FlashSale: React.FC = () => {
  return (
    <div className="campaign__container">
      <div className="campaign__wrapper">
        <div className="py-6 px-4 border border-dashed border-neutral-300 bg-neutral-50 rounded text-center text-neutral-500 font-sans">
          <p className="text-[10px] font-extrabold uppercase tracking-widest text-neutral-800">Flash Sale with Timer</p>
          <p className="text-[9px] text-neutral-400 mt-1">Countdown & discounted products</p>
        </div>
      </div>
    </div>
  );
};

export default Campaign;
